import React from 'react';
import { useCountdown } from '../hooks/useCountdown';
import { price } from '../data/content';
const pad = (n: number) => n.toString().padStart(2, '0');
export function CountdownBar() {
  const {
    days,
    hours,
    minutes,
    seconds
  } = useCountdown();
  const units = [{
    value: days,
    label: 'days'
  }, {
    value: hours,
    label: 'hours'
  }, {
    value: minutes,
    label: 'minutes'
  }, {
    value: seconds,
    label: 'seconds'
  }];
  return <div className="sticky top-0 z-40 w-full border-b-2 border-ink bg-ink text-cream" data-id="element-28" data-mp="2mfyjcxpeh7ai">
      <div className="mx-auto flex max-w-6xl flex-col items-center justify-center gap-1 px-3 py-2 sm:flex-row sm:gap-6 sm:px-4 sm:py-2.5" data-id="element-29" data-mp="2heixx4jb8yrl">
        <p className="font-display text-[11px] font-bold uppercase tracking-wider text-rust sm:text-sm" data-id="element-30" data-mp="2ci0vibbgdcif">
          The {price.today} offer ends in
        </p>
        <div className="flex items-center gap-1.5 sm:gap-2" role="timer" aria-live="off" data-id="element-31" data-mp="anjhqbl2rkpd">
          {units.map((u, i) => <React.Fragment key={u.label} data-id="element-32" data-mp="6nr3pjcwwmcm" data-mpi={i}>
              <div className="flex items-baseline gap-1" data-id="element-33" data-mp="13eacht3ya7cc">
                <span className="font-display text-lg font-black tabular-nums sm:text-2xl" data-id="element-34" data-mp="13cphk2dq4mdy">{pad(u.value)}</span>
                <span className="text-[11px] text-kraft-light sm:text-xs" data-id="element-35" data-mp="18b0tcinkx6yt">{u.label}</span>
              </div>
              {i < units.length - 1 && <span className="font-display text-lg font-black text-kraft-dark" data-id="element-36" data-mp="yeo35ur8tb8t">:</span>}
            </React.Fragment>)}
        </div>
      </div>
    </div>;
}